import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

// Material UI Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import ProductForm from '../../../forms/product/ProductForm';
import Button from '../../../components/formElements/Button';

function AddProduct() {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      {/* Nagłówek z przyciskiem powrotu */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <div className="flex flex-col items-center gap-2">
            <Button
              onClick={() => {
                navigate('/admin/produkty');
              }}
              colorTheme="outline"
              className="w-auto px-3 py-1.5"
            >
              <ArrowBackIcon fontSize="small" className="mr-1" />
              Powrót
            </Button>
          </div>
        </div>
      </div>

      {/* Formularz produktu */}
      <ProductForm />
    </motion.div>
  );
}

export default AddProduct;
